// eslint-disable-next-line @typescript-eslint/no-use-before-define
import React from 'react';
import {
    withStyles,
    Grid,
    Typography,
    Paper,
    ExpansionPanel,
    ExpansionPanelSummary,
    ExpansionPanelDetails,
} from '@material-ui/core';
import styles, { StyledComponent } from '../../../../../styles/styles';
import { LabeledValue } from '../../../../../controls/labeled-value';
import { FormDetails, getFormDetails } from '../form-details-reducer';
import { connect } from 'react-redux';
import { State } from '../../../../../redux/root-reducer';
import { OpenModal, openModalAction } from '../../../../../form-modal/actions';
import { UpdateFormDetails, updateFormDetailsAction } from '../actions/update-form-details';
import { Nullable } from '../../../../../shared-types';
import { ClaimType } from '../../../../../claim/claim-types';
import { getClaim } from '../../../../../claim';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { formatCurrency, getDisplayDate } from '../../../../../shared-functions';

interface BaseProps {
    formDetails?: FormDetails;
    updateFormDetails?: UpdateFormDetails;
    disableEditButton?: boolean;
    claimType?: Nullable<ClaimType>;
}
interface Props extends BaseProps, StyledComponent {
    readonly openModal: OpenModal;
}

const otherDisabilityInsuranceView: React.FunctionComponent<Props> = ({
    classes,
    formDetails,
    updateFormDetails,
    openModal,
    claimType,
}: Props) => {
    if (claimType === ClaimType.TerminalIllness || claimType === ClaimType.Dread) {
        return null;
    }
    const otherInsurancePolicies = formDetails?.lifeAssured?.otherInsurancePolicies;
    const insuranceCompany =
        formDetails?.lifeAssured?.otherInsurancePolicies?.otherInsurance?.insuranceCompany;
    return (
        <React.Fragment>
            <Grid container justify="space-between" className={classes.marginTop2}>
                <Grid container item xs={12} alignItems="center">
                    <Typography variant="h6" className={classes.heading}>
                        Other Disability Insurance
                    </Typography>
                </Grid>
            </Grid>
            <Paper className={classes.paper} elevation={3}>
                {claimType === ClaimType.Disability && (
                    <Grid container spacing={2}>
                        {/* Column One Start */}
                        <Grid container item xs={12} sm={12} direction="column">
                            <Grid item>
                                <LabeledValue
                                    label="Have you claimed or intend on claiming for payment of disability, dread diseases, impairment or any similar benefits with other insurance company?"
                                    value={
                                        otherInsurancePolicies?.otherInsurance
                                            ?.haveYouClaimedOrDoYouIntendOnClaimingForPaymentOfDisabilityDreadDiseasesImpairmentOrAnySimilarBenefitsWithOtherInsuranceCompany ||
                                        otherInsurancePolicies?.otherInsurance
                                            ?.CoHaveYouClaimedOrDoYouIntendOnClaimingForPaymentOfDisabilityDreadDiseasesImpairmentOrAnySimilarBenefitsWithOtherInsuranceCompany
                                    }
                                />
                            </Grid>
                            {otherInsurancePolicies?.otherInsurance
                                ?.haveYouClaimedOrDoYouIntendOnClaimingForPaymentOfDisabilityDreadDiseasesImpairmentOrAnySimilarBenefitsWithOtherInsuranceCompany ===
                                'Yes' && (
                                <Grid item>
                                    <Typography variant="h6" style={{ marginBottom: '20px' }}>
                                        Insurance Cover
                                    </Typography>
                                    {insuranceCompany?.map((h, index) => (
                                        <ExpansionPanel key={index} style={{ width: '100%' }}>
                                            <ExpansionPanelSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls={`panel-content-${index}`}
                                                id={`panel-header-${index}`}
                                            >
                                                <Typography>{`Insurance Cover ${
                                                    index + 1
                                                }`}</Typography>
                                            </ExpansionPanelSummary>
                                            <ExpansionPanelDetails>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} sm={6} md={3}>
                                                        <LabeledValue
                                                            label="Name of insurance company"
                                                            value={h.nameOfInsuranceCompany}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} sm={6} md={3}>
                                                        <LabeledValue
                                                            label="Policy number"
                                                            value={h.policyNumber}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} sm={6} md={3}>
                                                        <LabeledValue
                                                            label="Date of Inception"
                                                            value={getDisplayDate(
                                                                h.dateOfInception
                                                            )}
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} sm={6} md={3}>
                                                        <LabeledValue
                                                            label="Estimated value"
                                                            value={formatCurrency(h.estimatedValue)}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </ExpansionPanelDetails>
                                        </ExpansionPanel>
                                    ))}
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                )}
            </Paper>
        </React.Fragment>
    );
};

const mapStateToProps = (state: State, ownProps: BaseProps) => ({
    formDetails: ownProps.formDetails || getFormDetails(state),
    disableEditButton: ownProps.disableEditButton || false,
    claimType: getClaim(state).claimType,
});

const mapDispatchToProps = {
    openModal: openModalAction,
    updateFormDetails: updateFormDetailsAction,
};

export const OtherDisabilityInsuranceView = connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(otherDisabilityInsuranceView));
